import BaseModel from "./BaseModel";

export default class SponsorModel extends BaseModel {
  address?: string | null;
  email?: string;
  name?: string;
  phone_number?: string | null;
  constructor(arg: any) {
    super(arg);
    this.address = arg.address;
    this.email = arg.email;
    this.name = arg.name;
    this.phone_number = arg.phone_number;
  }
}
